import { Table, Tbody, Th, Tr } from '@chakra-ui/react';
import React from 'react';

import type { InternalTransaction } from 'types/api/internalTransaction';

import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import { type AlltracexExchangeData } from 'lib/hooks/usePrice';
import { currencyUnits } from 'lib/units';
import { default as Thead } from 'ui/shared/TheadSticky';

import AddressIntTxsTableItem from './AddressIntTxsTableItem';

interface Props {
  data: Array<InternalTransaction>;
  currentAddress: string;
  isLoading?: boolean;
  priceAll?: AlltracexExchangeData;
}

const AddressIntTxsTable = ({ data, currentAddress, isLoading, priceAll }: Props) => {
  return (
    <AddressHighlightProvider>
      <Table variant="simple" size="sm">
        <Thead top={ 68 }>
          <Tr>
            <Th width="15%" bg="green.400" color="gray.600">Parent txn hash</Th>
            <Th width="15%" bg="green.400" color="gray.600">Type</Th>
            <Th width="10%" bg="green.400" color="gray.600">Block</Th>
            <Th width="40%" bg="green.400" color="gray.600">From/To</Th>
            <Th width="20%" isNumeric bg="green.400" color="gray.600">
              Value { currencyUnits.ether }
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          { data.map((item, index) => (
            <AddressIntTxsTableItem
              key={ item.transaction_hash + '_' + index }
              { ...item }
              currentAddress={ currentAddress }
              isLoading={ isLoading }
              priceAll={ priceAll }
            />
          )) }
        </Tbody>
      </Table>
    </AddressHighlightProvider>

  );
};

export default AddressIntTxsTable;
